import styled, { keyframes, css } from 'styled-components'

const toHide = keyframes`
   0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`

const toShow = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`

export const Icon = styled.div`
  box-sizing: border-box;
  position: relative;
  display: block;
  transform: scale(var(--ggs, 1));
  width: 15px;
  height: 15px;
  border: 2px solid transparent;
  border-radius: 100px;
  position: absolute;
  right: 5px;
  top: calc((100% - 13px) / 2);
  :after {
    content: '';
    display: block;
    box-sizing: border-box;
    position: absolute;
    width: 8px;
    height: 8px;
    border-top: 1px solid;
    border-right: 1px solid;
    transform: rotate(135deg) translateY(5px);
    left: 4px;
    bottom: 2px;
    border-color: #b3bcc6;
  }
`

export const SelectWrapper = styled.div`
  border: 1px solid #b3bcc6;
  padding: 6px 15px 6px 10px;
  min-width: 80px;
  font-size: 12px;
  position: relative;
  cursor: pointer;
  color: #7c7c7c;
`

export const OptionWrapper = styled.div`
  width: 100%;
  position: absolute;
  cursor: pointer;
  border: 1px solid #b3bcc6;
  z-index: 10;
  background: #fff;
  left: 0;
  top: calc(100% + 5px);
  transition: max-height 0.5s;
  overflow: hidden;
  display: ${({ displayOption }) => (displayOption ? 'block' : 'none')};
  ${({ show }) =>
    show
      ? css`
          animation: ${toShow} 0.2s linear;
        `
      : css`
          animation: ${toHide} 0.2s linear;
        `};
`

export const Option = styled.div`
  padding: 8px 10px;
  transition: all 0.5s;
  user-select: none;
  :hover {
    background: #f4f4f4;
  }
`
